export default __webpack_public_path__ + "static/1252-9060fb7efb4e5bb5aa7c6f0eecc6d243.gif";